import { ErrorNotice } from "@/components/tool-kit/primitives";
import { BUTTON_SECONDARY } from "@/components/tool-kit/styles";
import type { WordListStatus as Status } from "@/components/tools/word-games/use-word-list";

/** The loading line and the retry button for a word-list download. */
export function WordListStatus({
  status,
  onRetry,
  loading,
  error,
  retry,
}: {
  status: Status;
  onRetry: () => void;
  loading: string;
  error: string;
  retry: string;
}) {
  if (status === "loading") {
    return (
      <output className="block text-muted-foreground text-sm">{loading}</output>
    );
  }
  if (status === "error") {
    return (
      <div className="space-y-3">
        <ErrorNotice>{error}</ErrorNotice>
        <button className={BUTTON_SECONDARY} onClick={onRetry} type="button">
          {retry}
        </button>
      </div>
    );
  }
  return null;
}
